// Display text for eBay requests. The colour and the step states come from the
// worker (request.urgency, request.steps); nothing here decides urgency.

const MS_PER_HOUR = 3600 * 1000
const HOURS_SHOWN_AS_HOURS = 48

export const URGENCY_BADGE = {
  overdue: 'badge-error',
  red: 'badge-error',
  amber: 'badge-warning',
  ok: 'badge-neutral',
  none: 'badge-neutral'
}

export const URGENCY_BORDER = {
  overdue: 'var(--color-error)',
  red: 'var(--color-error)',
  amber: 'var(--color-warning)'
}

export const STEP_WORD = { done: 'Done', now: 'NOW', later: 'Later' }
export const KIND_LABEL = { return: 'Return', not_received: 'Not received' }

export function timeLeft(respondBy, now = new Date()) {
  if (!respondBy) return 'No deadline'
  const hours = (new Date(respondBy).getTime() - now.getTime()) / MS_PER_HOUR
  if (hours < 0) return 'OVERDUE'
  if (hours < 1) return 'in under 1 hour'
  if (hours < HOURS_SHOWN_AS_HOURS) return `in ${Math.round(hours)} hours`
  return `in ${Math.round(hours / 24)} days`
}

// eBay's deadlines are UK times (23:59 UK), so the date is always shown in UK
// time, whatever the browser's own zone is.
const DEADLINE_FORMAT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London',
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23'
})

/** The deadline as a date, for example "Tue 13 Oct, 23:59". Null when there is none. */
export function deadlineDate(respondBy) {
  if (!respondBy) return null
  const date = new Date(respondBy)
  if (Number.isNaN(date.getTime())) return null
  const parts = Object.fromEntries(DEADLINE_FORMAT.formatToParts(date).map(part => [part.type, part.value]))
  return `${parts.weekday} ${parts.day} ${parts.month}, ${parts.hour}:${parts.minute}`
}

export function nextStep(request) {
  return request.steps.find(step => step.state === 'now')?.label || 'Nothing for us to do right now'
}
